import jquery from 'jquery';
import 'bootstrap';

window.$ = window.jQuery = window.jquery = jquery;

import 'bootstrap';

$.ajaxSetup({
	headers: {
		'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	}
});
